module.exports =
  '_GROUP_MEMBERS':
    'EDIT_MEMBER': 'Edit member'
    'REQUEST': 'Request'
    'CLOSE': 'Close'
    'SEARCH_MEMBER': 'Search for members'
    'MEMBER': 'Member'
    'GROUP_ADMIN': 'Group Administrator'
    'DONE': 'Done'
    'APPROVAL': 'Approval'
    'DELETE_REQUEST': 'Delete request'
    'NO_NEW_REQUEST': 'No new requests'
    'NUMBER_REQUEST': '{0} requests'
    'ADMIN': 'Administrator'
    'DELETE_MEMBER': 'Delete members'
    'FINISH': 'Done'
    'TIME_AGO': 'Participated about {0}.'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-member/i18n/en.coffee